// extracted by mini-css-extract-plugin
module.exports = {"nbrCtlW":"number-ctrl_nbrCtlW__1o5mz","bt":"number-ctrl_bt__1Xp6O","nbr":"number-ctrl_nbr__1Zdlm"};